
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import A1 from '../Images/Signature.png'

const QuestionsList = () => {
    const { userId } = useParams();
    const [questions, setQuestions] = useState([]);
    const [selectedAnswers, setSelectedAnswers] = useState({});
    const [results, setResults] = useState([]);
    const [showResults, setShowResults] = useState(false);
    const [userInfo, setUserInfo] = useState({ name: '', email: '', mobile: '', });
    const [formError, setFormError] = useState('');
    const [answeredQuestions, setAnsweredQuestions] = useState({});
    const [events, setEvents] = useState([]);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [timers, setTimers] = useState({});
    const [intervals, setIntervals] = useState({})

    const [loading, setLoading] = useState(false);

    const [formSubmitted, setFormSubmitted] = useState(false);
    const [questionStartTimes, setQuestionStartTimes] = useState({});
    useEffect(() => {
        fetchEvents();
    }, [userId]);

    useEffect(() => {
        if (formSubmitted && userId && events.length > 0) {
            const activeEvent = events.find(event => event.flag === 1);
            const eventId = activeEvent ? activeEvent.id : null;

            if (!eventId) {
                console.warn('No active event found.');
                return;
            }

            axios.get(`https://rvapi.emedha.in/pages/api/api/questions?userId=${userId}&eventId=${eventId}`)
                .then(response => {
                    console.log('Questions:', response.data);
                    setQuestions(response.data);
                    startTimerForQuestion(response.data[0]?.id, response.data[0]?.time);
                })
                .catch(error => {
                    console.log('Error fetching questions:', error.message);
                });
        }
    }, [formSubmitted, userId, events]);


    const handleUserInfoSubmit = () => {
        if (!userInfo.name || !userInfo.email || !userInfo.mobile) {
            setFormError('Please fill in all fields (Name, Email, and Mobile).');
            return;
        }
        setFormError('');
        setFormSubmitted(true);
    };

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            event.preventDefault();
            event.returnValue = '';
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [])

    const startTimerForQuestion = (questionId, durationInMinutes) => {
        // If no time is provided, treat as infinite time (do not start timer)
        if (durationInMinutes === null || durationInMinutes === undefined || isNaN(durationInMinutes)) {
            setTimers(prev => ({ ...prev, [questionId]: null })); // You can mark as null or '∞'
            return;
        }
        const durationInSeconds = durationInMinutes * 60;
        setTimers(prev => ({ ...prev, [questionId]: durationInSeconds }));
        setQuestionStartTimes(prev => ({ ...prev, [questionId]: Date.now() }));
        const interval = setInterval(() => {
            setTimers(prev => {
                const updatedTimers = { ...prev };
                if (updatedTimers[questionId] > 0) {
                    updatedTimers[questionId] -= 1;
                } else {
                    clearInterval(interval);
                    handleSubmitQuestion(questions[currentQuestionIndex]);
                }
                return updatedTimers;
            });
        }, 1000);
        setIntervals(prev => ({ ...prev, [questionId]: interval }));
    };

    const stopTimerForQuestion = (questionId) => {
        const interval = intervals[questionId];
        if (interval) {
            clearInterval(interval);
            setTimers((prevTimers) => ({ ...prevTimers, [questionId]: 0 }));
        }
    };
    const handleChange = (questionId, selectedOption) => {
        setSelectedAnswers(prevAnswers => ({
            ...prevAnswers,
            [questionId]: selectedOption,
        }));
    };
    const handleCheckboxChange = (questionId, selectedOption) => {
        setSelectedAnswers(prevAnswers => {
            const current = prevAnswers[questionId] || [];
            if (current.includes(selectedOption)) {
                return {
                    ...prevAnswers,
                    [questionId]: current.filter(opt => opt !== selectedOption)
                };
            } else {
                return {
                    ...prevAnswers,
                    [questionId]: [...current, selectedOption]
                };
            }
        });
    };
    const handleSubmitQuestion = (question) => {
        if (!question || !question.id) {
            console.error('Invalid question data:', question);
            return;
        }

        stopTimerForQuestion(question.id);

        const selectedAnswer = selectedAnswers[question.id];
        let correctAnswer = question.correct_answer ? question.correct_answer.trim() : '';
        if (!correctAnswer && question.correct_image) {
            correctAnswer = question.correct_image;
        }

        const userAnswer = selectedAnswer ? selectedAnswer.trim() : '';
        const isCorrect = userAnswer === correctAnswer;

        const startTime = questionStartTimes[question.id];
        const timeTaken = startTime ? Math.floor((Date.now() - startTime) / 1000) : null;
        setResults(prevResults => [...prevResults, {
            questionId: question.id,
            selectedAnswer: userAnswer,
            isCorrect,
            correctAnswer,
            timeTaken,
        }]);
        setAnsweredQuestions(prevState => ({ ...prevState, [question.id]: true }));
        axios.post('https://rvapi.emedha.in/pages/api/submit-fastest-answer', {
            questionId: question.id,
            userId,
            name: userInfo.name,
            email: userInfo.email,
            mobile: userInfo.mobile,
            timeTaken,
            isCorrect
        }).then(res => {
            console.log('Fastest answer submitted:', res.data);
        }).catch(err => {
            console.error('Error submitting fastest answer:', err);
        });
        if (currentQuestionIndex + 1 < questions.length) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
        }
    };

    useEffect(() => {
        if (currentQuestionIndex < questions.length) {
            const question = questions[currentQuestionIndex];
            startTimerForQuestion(question.id, question.time);
        }
    }, [currentQuestionIndex, questions]);


    const handleFinishQuiz = () => {
        if (!userInfo.name || !userInfo.email || !userInfo.mobile) {
            setFormError('Please fill in all fields (Name, Email, and Mobile).');
            return;
        }

        setFormError('');
        setLoading(true); // Show loading spinner

        const totalMarks = results.filter(result => result.isCorrect).length * 10;

        const postData = {
            name: userInfo.name,
            email: userInfo.email,
            mobile: userInfo.mobile,
            totalMarks: totalMarks,
            userId: userId,
            eventName: events[0]?.name || '',
            eventFile: events[0]?.file || '',
        };

        axios.post('https://rvapi.emedha.in/pages/api/submit-quizcertificate', postData)
            .then(response => {
                console.log('Quiz results submitted:', response.data);
                alert('🎉 Your quiz has been submitted!');
                setShowResults(true); // Show results after submit
            })
            .catch(error => {
                console.error('Error submitting quiz results:', error);

                if (error.response && error.response.data && error.response.data.error) {
                    if (error.response.data.error.includes('email')) {
                        alert('⚠️ This email has already been used. Please use a different email.');
                    } else {
                        alert(`❌ ${error.response.data.error}`);
                    }
                } else {
                    alert('Something went wrong while submitting the quiz. Please try again.');
                }
            })
            .finally(() => {
                setLoading(false); // Hide loading spinner
            });
    };




    const fetchEvents = async () => {
        try {
            const response = await axios.get(`https://rvapi.emedha.in/pages/api/api/events?userId=${userId}`);
            const filteredEvents = response.data.filter(event => event.flag === 1);
            setEvents(filteredEvents);
            setEvents(response.data);
        } catch (error) {
            console.error(error);
        }
    };

    const formatTime = (seconds) => {
        if (seconds === null) return '∞'; // Or 'No Time Limit'
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes}:${secs < 10 ? `0${secs}` : secs}`;
    };

    return (
        <div style={{ fontFamily: 'Arial, sans-serif', backgroundColor: '#f4f4f9', maxWidth: '800px', margin: '20px auto', padding: '20px', borderRadius: '8px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
            <div className='mb-2' style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f4f4f4', borderRadius: '8px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
                {events.length > 0 && (
                    events.filter(event => event.flag === 1)
                        .map(event => (
                            <div key={event.id}>
                                <img src={event.file} alt="Logo" style={{ width: '100px', borderRadius: '10px' }} />
                                <h2 style={{ color: '#333', fontSize: '24px', fontWeight: '600', marginBottom: '15px' }}>{event.name}</h2>
                            </div>
                        ))
                )}
            </div>

            <div>
                <img className='mt-5' src={A1} alt="Logo" style={{ width: '10px' }} />
            </div>

            {!formSubmitted && (
                <div style={{ marginTop: '20px' }}>
                    <input type="text" placeholder="Enter your Name" value={userInfo.name} onChange={(e) => setUserInfo({ ...userInfo, name: e.target.value })} style={{ display: 'block', padding: '10px', margin: '10px 0', borderRadius: '4px', border: '1px solid #ddd', width: '100%' }} />
                    <input type="email" placeholder="Enter your Email" value={userInfo.email} onChange={(e) => setUserInfo({ ...userInfo, email: e.target.value })} style={{ display: 'block', padding: '10px', margin: '10px 0', borderRadius: '4px', border: '1px solid #ddd', width: '100%' }} />
                    <input type="text" placeholder="Enter your Mobile" value={userInfo.mobile} onChange={(e) => setUserInfo({ ...userInfo, mobile: e.target.value })} style={{ display: 'block', padding: '10px', margin: '10px 0', borderRadius: '4px', border: '1px solid #ddd', width: '100%' }} maxLength={10} />
                    {formError && <div style={{ color: 'red', fontSize: '14px', textAlign: 'center' }}>{formError}</div>}
                    <button style={{ backgroundColor: '#007BFF', width: '100%', color: 'white', padding: '10px 20px', border: 'none', borderRadius: '4px', cursor: 'pointer', marginTop: '10px' }} onClick={handleUserInfoSubmit}>Start Quiz</button>
                </div>
            )}

            {formSubmitted && (
                <>
                    <div>
                        {questions.length > 0 ? (
                            questions.map((question) => (
                                <div key={question.id} style={{ backgroundColor: '#fff', padding: '20px', marginBottom: '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' }}>
                                    <h3>{question.title}</h3>
                                    <p>{question.question}</p>
                                    <div><strong>Time Remaining: </strong><span>{timers[question.id] !== undefined ? formatTime(timers[question.id]) : 'Loading...'}</span></div>
                                    {question.images1 && question.images2 && question.images3 && question.images4 ? (
                                        <div>
                                            <h4>Select the correct image:</h4>
                                            {[question.images1, question.images2, question.images3, question.images4].map((image, index) => (
                                                <div key={index}>
                                                    <input type="radio" name={`image_${question.id}`} value={image} onChange={() => handleChange(question.id, image)} checked={selectedAnswers[question.id] === image} disabled={answeredQuestions[question.id]} />
                                                    <img src={image} alt={`Option ${index + 1}`} style={{ width: '100px', height: '100px', margin: '5px' }} />
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <div>
                                            {['option_1', 'option_2', 'option_3', 'option_4'].map((option, index) => {
                                                if (question[option]) {
                                                    return (
                                                        <div key={index}>
                                                            <label style={{ display: 'block', padding: '8px', margin: '5px 0', borderRadius: '4px', backgroundColor: '#f0f0f0', cursor: 'pointer' }}>
                                                                <input type="radio" name={`question_${question.id}`} value={question[option]} onChange={() => handleChange(question.id, question[option])} checked={selectedAnswers[question.id] === question[option]} disabled={answeredQuestions[question.id]} />
                                                                {question[option]}
                                                            </label>
                                                        </div>
                                                    );
                                                }
                                                return null;
                                            })}
                                        </div>
                                    )}

                                    {question.checkbox_options && (
                                        <div>
                                            <h4>Select all correct options:</h4>
                                            {question.checkbox_options.map((option, index) => (
                                                <div key={index}>
                                                    <label style={{ display: 'block', padding: '8px', margin: '5px 0', borderRadius: '4px', backgroundColor: '#f0f0f0', cursor: 'pointer' }}>
                                                        <input type="checkbox" name={`checkbox_${question.id}`} value={option} onChange={() => handleCheckboxChange(question.id, option)} checked={selectedAnswers[question.id] && selectedAnswers[question.id].includes(option)} disabled={answeredQuestions[question.id]} />
                                                        {option}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    {results.some(result => result.questionId === question.id) && (
                                        <div style={{ marginTop: '10px' }}>
                                            <p>Correct Answer: {question.correct_answer}</p>
                                            {question.correct_image && (<div><p>Correct Answer Image:</p><img src={question.correct_image} alt="Correct" style={{ width: '150px', height: '150px' }} /></div>)}
                                        </div>
                                    )}
                                    <button style={{ backgroundColor: '#4CAF50', color: 'white', padding: '10px 20px', border: 'none', borderRadius: '4px', cursor: 'pointer', marginTop: '10px' }} onClick={() => handleSubmitQuestion(question)} disabled={answeredQuestions[question.id]} >Submit Answer</button>
                                    {results.some(result => result.questionId === question.id) && (
                                        <div style={{ padding: '10px', marginTop: '10px', borderRadius: '4px', backgroundColor: results.find(result => result.questionId === question.id).isCorrect ? '#90EE90' : '#f8d7da', }}>
                                            {results.find(result => result.questionId === question.id).isCorrect ? (
                                                <div>
                                                    <p>Correct! You scored 10 marks.</p>
                                                    <p>Correct Answer: {question.correct_answer}</p>
                                                    {question.correct_image && (
                                                        <div><p>Correct Image:</p><img src={question.correct_image} alt="Correct Answer" style={{ width: '150px', height: '150px' }} /></div>
                                                    )}
                                                </div>
                                            ) : (
                                                <div>
                                                    <p>Incorrect! You scored 0 marks.</p>
                                                    <p>Correct Answer: {question.correct_answer}</p>
                                                    {question.correct_image && (
                                                        <div><p>Correct Image:</p><img src={question.correct_image} alt="Correct Answer" style={{ width: '150px', height: '150px' }} /></div>
                                                    )}
                                                    <p>Your Answer: {selectedAnswers[question.id]}</p>
                                                </div>
                                            )}
                                        </div>
                                    )}

                                </div>
                            ))
                        ) : (
                            <div>No questions available</div>
                        )}
                    </div>

                    <button
                        style={{ backgroundColor: '#4CAF50', color: 'white', padding: '10px 20px', border: 'none', borderRadius: '4px', cursor: loading ? 'not-allowed' : 'pointer', marginTop: '20px' }}
                        onClick={handleFinishQuiz}
                        disabled={loading}
                    >
                        Finish Quiz
                    </button>
                    {loading && (
                        <div style={{ marginTop: '20px', textAlign: 'center' }}>
                            <div className="spinner" style={{
                                border: "4px solid #f3f3f3",
                                borderTop: "4px solid #3498db",
                                borderRadius: "50%",
                                width: "30px",
                                height: "30px",
                                animation: "spin 1s linear infinite",
                                margin: "0 auto"
                            }}></div>
                            <p>Submitting your results, please wait...</p>
                        </div>
                    )}


                    {showResults && (
                        <div style={{ backgroundColor: '#f9f9f9', padding: '15px', borderRadius: '8px', textAlign: 'center', fontSize: '16px' }}>
                            <h3>Your Results</h3>
                            <p>You completed the quiz. Your total score is {results.filter(result => result.isCorrect).length * 10} marks.</p>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default QuestionsList;
